<mat-dialog-content class="center">
    <qrcode [hidden]="isLoading()" [qrdata]="url()" [width]="256" [allowEmptyString]="true" />
    @if (isLoading()) {
        <div>{{ 'General.Loading' | translate }}...</div>
    }
</mat-dialog-content>
@if (!isLoading()) {
    <mat-dialog-actions>
        <button
            mat-icon-button
            [cdkCopyToClipboard]="url()"
            (cdkCopyToClipboardCopied)="onCopied()"
            [matTooltip]="'General.CopyUrlToClipboard' | translate">
            <mat-icon>link</mat-icon>
        </button>
        <button
            mat-icon-button
            [cdkCopyToClipboard]="token()"
            (cdkCopyToClipboardCopied)="onCopied()"
            [matTooltip]="'General.CopyTokenToClipboard' | translate">
            <mat-icon>vpn_key</mat-icon>
        </button>
        <button mat-icon-button (click)="downloadLink()" [matTooltip]="'GateQrCodeDialog.DownloadLink' | translate">
            <mat-icon>sim_card_download</mat-icon>
        </button>
        <div class="flex-grow-1"></div>
        <button mat-button mat-dialog-close cdkFocusInitial>{{ 'General.Close' | translate }}</button>
    </mat-dialog-actions>
}
